import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import styled from "styled-components";
import MainLayout from "./pages/layouts/MainLayout";
import BlankLayout from "./pages/layouts/BlankLayout";
// import OurProducts from "./pages/OurProducts";
import AppHomepage from "./pages/AppHomepage";
// import LaiyinlianqinTeacher from "./pages/LaiyinlianqinTeacher";
// import AboutUs from "./pages/AboutUs";
// import SocialResponsibility from "./pages/SocialResponsibility";
// import MoreApplications from "./pages/MoreApplications";
// import ShowAllIcon from "./pages/ShowAllIcons";
import LaiYinSeries from "./pages/LaiYinSeries";
import LingGanSeries from "./pages/LingGanSeries";

export default function App() {
  return (
    <Wrapper>
      <Routes>
        {/* 主布局 */}
        <Route element={<MainLayout />}>
          <Route path="/laiyinSeries" element={<LaiYinSeries />} />
          <Route path="/lingganSeries" element={<LingGanSeries />} />
          {/* <Route path="/ourProducts" element={<OurProducts />} />
          <Route
            path="/laiyinlianqinTeacher"
            element={<LaiyinlianqinTeacher />}
          />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route
            path="/socialResponsibility"
            element={<SocialResponsibility />}
          />
          <Route path="/moreApplications" element={<MoreApplications />} />
          <Route path="/allIcons" element={<ShowAllIcon />} /> */}
        </Route>

        {/* 空白布局 */}
        <Route element={<BlankLayout />}>
          <Route path="/appHomepage" element={<AppHomepage />} />
        </Route>

        <Route path="*" element={<Navigate to="/laiyinSeries" />} />
      </Routes>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
`;
